import {
  checkIsBot,
  getAerialDistanceFromLatLong,
  getAirportUrl,
  getCurrencyForCountry,
  getDateTimeDDMMYYY,
  getDisplayableName,
  getFareCalendarUrl,
  getFlightScheduleUrl,
  getSeoFlightUrl,
} from "./CommonUtils";
import {
  AIRLINE,
  AIRLINE_TO_PNR_MAP,
  AIRPORT,
  AIRPORT_MAPPED_TO_COUNTRY,
  AIRPORT_NAME,
  ARABIC_URL_CHECK,
  CITY,
  CURRENT_TEMPLATE,
  DATE_FORMAT,
  DATE_FORMAT_PLUS_2,
  DATE_FORMAT_PLUS_4,
  DATE_FORMAT_PLUS_D2,
  DEST_AIRPORT,
  DEST_CITY,
  DF_CITY_TEMPLATE,
  DF_DISTANCE_TEMPLATE,
  ENTITY_TYPE_AIRLINE,
  HINDI_URL_CHECK,
  IFAIRPORT,
  IFCITY,
  IFCOUNTRY,
  IF_AIRPORT_LIST,
  IF_DEST_CITY,
  IF_DEST_CITY_AIRPORT_LIST,
  IF_DEST_COUNTRY,
  IF_SRC_CITY,
  IF_SRC_CITY_AIRPORT_LIST,
  IF_SRC_COUNTRY,
  INTL_AIRLINE,
  JRNY_DEST_CITY,
  JRNY_SRC_CITY,
  PATH_VAR_ALPHA,
  PATH_VAR_ALPHA_DIGIT,
  SRC_AIRPORT,
  SRC_CITY,
  TEMPLATE,
  TOKENS,
  TOKEN_ABOUT_AIRLINE_TEXT,
  TOKEN_ABOUT_AIRPORT,
  TOKEN_ABOUT_AIRPORT_CITY,
  TOKEN_ABOUT_CITY,
  TOKEN_ABOUT_COUNTRY,
  TOKEN_ABOUT_DEST_CITY,
  TOKEN_ABOUT_DES_COUNTRY,
  TOKEN_ABOUT_SRC_CITY,
  TOKEN_ABOUT_SRC_COUNTRY,
  TOKEN_AIRLINE_AL_URL_PHRASE,
  TOKEN_AIRLINE_BAGGAGE_INFO_HTML,
  TOKEN_AIRLINE_CODE,
  TOKEN_AIRLINE_CODE_LOWER_CASE,
  TOKEN_AIRLINE_CONTACT_INFO_HTML,
  TOKEN_AIRLINE_DESCRIPTION,
  TOKEN_AIRLINE_HISTORY,
  TOKEN_AIRLINE_INFLIGHT_SERVICES,
  TOKEN_AIRLINE_INSURANCE_HTML,
  TOKEN_AIRLINE_LOGO_URL,
  TOKEN_AIRLINE_NAME,
  TOKEN_AIRLINE_SERVICES_HTML,
  TOKEN_AIRLINE_URL_PHRASE,
  TOKEN_AIRLINE_WEB_CHECKIN_HTML,
  TOKEN_AIRPORT_ADDRESS,
  TOKEN_AIRPORT_CODE,
  TOKEN_AIRPORT_CODE_LOWER_CASE,
  TOKEN_AIRPORT_COUNTRY,
  TOKEN_AIRPORT_DESCRIPTION,
  TOKEN_AIRPORT_LATITUDE,
  TOKEN_AIRPORT_LONGITUDE,
  TOKEN_AIRPORT_NAME,
  TOKEN_AIRPORT_URL,
  TOKEN_AIRPORT_URL_PHRASE,
  TOKEN_AR_AIRLINE_NAME,
  TOKEN_AR_CITY_NAME,
  TOKEN_AR_COUNTRY_NAME,
  TOKEN_AR_DES_CITY_NAME,
  TOKEN_AR_DES_COUNTRY_NAME,
  TOKEN_AR_SRC_CITY_NAME,
  TOKEN_AR_SRC_COUNTRY_NAME,
  TOKEN_CITY_CODE,
  TOKEN_CITY_FLIGHT_CODE,
  TOKEN_CITY_NAME,
  TOKEN_CITY_PLACE_CODE,
  TOKEN_CITY_URL,
  TOKEN_CITY_URL_PHRASE,
  TOKEN_COUNTRY_CODE,
  TOKEN_COUNTRY_FOLDER_CODE,
  TOKEN_COUNTRY_NAME,
  TOKEN_COUNTRY_PLACE_CODE,
  TOKEN_COUNTRY_URL,
  TOKEN_CURRENCY_CODE,
  TOKEN_DEST_CITY_AIRPORT_CODE,
  TOKEN_SRC_CITY_AIRPORT_CODE,
  TOKEN_DEST_CITY_AIRPORT_DESCRIPTION,
  TOKEN_DEST_CITY_AIRPORT_NAME,
  TOKEN_DEST_CITY_URL,
  TOKEN_DES_CITY_CODE,
  TOKEN_DES_CITY_FLIGHT_CODE,
  TOKEN_DES_CITY_NAME,
  TOKEN_DES_CITY_PLACE_CODE,
  TOKEN_DES_COUNTRY_CODE,
  TOKEN_DES_COUNTRY_NAME,
  TOKEN_DES_COUNTRY_PLACE_CODE,
  TOKEN_DES_COUNTRY_URL,
  TOKEN_FLIGHT_CITY,
  TOKEN_FLIGHT_CITY_URL,
  TOKEN_H1_TITLE,
  TOKEN_HINDI_PAGES_AIRLINE_URL_PHRASE,
  TOKEN_HI_CITY_NAME,
  TOKEN_HI_COUNTRY_NAME,
  TOKEN_HI_DES_CITY_NAME,
  TOKEN_HI_DES_COUNTRY_NAME,
  TOKEN_HI_SRC_CITY_NAME,
  TOKEN_HI_SRC_COUNTRY_NAME,
  TOKEN_LOCUS_CITY_CODE,
  TOKEN_PNR_STATUS_URL,
  TOKEN_ROUTE_URL_PATH,
  TOKEN_SRC_CITY_AIRPORT_DESCRIPTION,
  TOKEN_SRC_CITY_AIRPORT_NAME,
  TOKEN_SRC_CITY_CODE,
  TOKEN_SRC_CITY_FLIGHT_CODE,
  TOKEN_SRC_CITY_NAME,
  TOKEN_SRC_CITY_PLACE_CODE,
  TOKEN_SRC_CITY_URL,
  TOKEN_SRC_COUNTRY_CODE,
  TOKEN_SRC_COUNTRY_NAME,
  TOKEN_SRC_COUNTRY_PLACE_CODE,
  TOKEN_SRC_COUNTRY_URL,
  URL_CURRENT,
  TOKEN_ROAD_DISTANCE,
  TOKEN_DEST_CITY_AIRPORT_ADDRESS,
  TOKEN_SRC_CITY_AIRPORT_ADDRESS,
  URL_ATTRIBUTE_COUNTRY,
  TOKEN_SRC_LOCUS_CODE,
  TOKEN_DES_LOCUS_CODE,
} from "./Constants";

export const tokenReplace = (str, tokens, skipNotExistToken = false) => {
  if (!str) return "";
  let strUtil = str;
  const tokensFound = strUtil?.match(/\$\{([a-zA-Z0-9_]+)\}|{([a-zA-Z0-9_]+)}/gi);
  if (tokensFound) {
    tokensFound.forEach((item) => {
      const token = item?.replace(/[^A-Za-z0-9_]/gi, "");
      if (skipNotExistToken && token && !(token in tokens) && !(token?.toLowerCase() in tokens)) {
        return;
      }
      strUtil = strUtil?.replace(
        new RegExp(`{${token}}|\\$\{${token}}`, "gi"),
        tokens[token] || tokens[token?.toLowerCase()],
      );
    });
  }
  return strUtil;
};

export const giTokenReplace = (str, tokens, withSpace = true) => {
  if (!str) return "";
  let strUtil = str;
  if (withSpace) {
    return tokenReplace(strUtil, tokens, true);
  }

  const tokensFound = strUtil?.match(/\$\{ ([a-zA-Z0-9_]+) \}|{ ([a-zA-Z0-9_]+) }/gi);
  if (tokensFound) {
    tokensFound.forEach((item) => {
      const token = item?.replace(/[^A-Za-z0-9_]/gi, "");
      if (token in tokens || token?.toLowerCase() in tokens) {
        strUtil = strUtil?.replace(
          new RegExp(`{ ${token} }|\\$\{ ${token} }`, "gi"),
          tokens[token] || tokens[token?.toLowerCase()],
        );
      }
    });
  }
  return strUtil;
};

export const setTokens = (data) => {
  const dataMap = { ...data };
  const { localeSettings } = dataMap;
  let tokenData = dataMap[TOKENS] || {};
  const { isIntl } = dataMap;
  if (!isIntl) {
    tokenData = setFlightTokens(dataMap, tokenData);
  } else {
    tokenData = setIntlFlightsTokens(dataMap, tokenData);
  }
  const { src_country_code, dest_country_code } = tokenData;

  const isWW =
    typeof localeSettings?.isWorldwide !== "undefined"
      ? parseInt(localeSettings?.isWorldwide, 10)
      : 0;
  let userCountry = isWW ? localeSettings?.userCountry : localeSettings?.region;
  tokenData.currency = dataMap.userCurrency || "INR";
  tokenData.user_preferred_currency = dataMap.userCurrency || "INR";
  tokenData.user_country = userCountry;
  const gccCountries = ["ae", "sa", "qa", "bh", "kw", "om"];
  const userCountries = ["in", "sa", "ae", "qa", "bh", "kw", "om"];
  const gccCountriesExceptUAE = ["sa", "qa", "bh", "kw", "om"];
  if (userCountry.toLowerCase() === "in") {
    tokenData.regionType = "INIO";
  } else if (userCountry.toLowerCase() === "ae") {
    tokenData.regionType = "UAE";
  } else if (gccCountriesExceptUAE.includes(userCountry.toLowerCase())) {
    tokenData.regionType = "GCC";
  } else if (!userCountries.includes(userCountry.toLowerCase())) {
    if (src_country_code && dest_country_code) {
      if (
        dest_country_code.toLowerCase() === "in" ||
        (src_country_code.toLowerCase() === "in" &&
          !gccCountries.includes(dest_country_code.toLowerCase()))
      ) {
        tokenData.regionType = "INIO";
      } else if (
        gccCountries.includes(dest_country_code.toLowerCase()) ||
        (gccCountries.includes(src_country_code.toLowerCase()) &&
          dest_country_code.toLowerCase() !== "in")
      ) {
        tokenData.regionType = "GCC";
      }
      tokenData.sectorType = `${src_country_code.toLowerCase()}|${dest_country_code.toLowerCase()}`;
    }
  } else {
    tokenData.regionType = "A2A";
  }
  tokenData.is_bot_user = checkIsBot(dataMap?.userAgent || "") ? "BOT" : "";
  if (dataMap.flight_code) {
    tokenData.flight_code = dataMap.flight_code;
    tokenData.airline_num = dataMap.flight_code.replace(/_/g, " ").toUpperCase();
  }
  dataMap[TOKENS] = tokenData;
  return dataMap;
};

const COUNTRY_ABOUT_CITY_KEYS = [
  'united_states',
  'canada',
  'singapore',
  'australia',
  'united_kingdom',
  'bahrain',
  'oman',
  'qatar',
  'kuwait',
];

const getAboutCityValue = (city, dataMap) => {
  const { currentDomainName, isGoibibo, country_folder } = dataMap;
  const defaultAboutCity = city?.about_city || city?.name || '';

  // For Goibibo, use default logic
  if (isGoibibo) {
    return defaultAboutCity;
  }

  let regionalAboutCity = '';

  // Domain-specific about city mapping
  if (currentDomainName?.includes('ae.makemytrip.global')) {
    regionalAboutCity = city?.about_src_city_gcc;
  } else if (currentDomainName?.includes('sa.makemytrip.global')) {
    regionalAboutCity = city?.about_src_city_ksa;
  } else if (currentDomainName?.includes('www.makemytrip.global')) {
    // Check country_folder for country-specific about city
    if (country_folder && COUNTRY_ABOUT_CITY_KEYS.includes(country_folder)) {
      regionalAboutCity = city?.[`about_city_${country_folder}`];
    }
    // Fallback to global if country-specific not found
    if (!regionalAboutCity) {
      regionalAboutCity = city?.about_src_city_global;
    }
  }

  // Fallback chain: regional → about_city → city.name
  return regionalAboutCity || defaultAboutCity;
};

const setIntlFlightsTokens = (data, tokens) => {
  const dataMap = { ...data };
  const tokenData = { ...tokens };
  const url = dataMap[URL_CURRENT];
  if (url && url.startsWith("/")) {
    tokenData.url = url.substring(1);
  }
  const date = new Date();
  let dayPlus10 = date.getDate() + 10;
  let dayPlus2 = date.getDate() + 2;
  let dayPlus4 = date.getDate() + 4;
  let month = date.getMonth() + 1;
  const year = date.getFullYear();
  dayPlus2 = dayPlus2 < 10 ? `0${dayPlus2}` : dayPlus2;
  // eslint-disable-next-line no-unused-vars
  dayPlus4 = dayPlus4 < 10 ? `0${dayPlus4}` : dayPlus4;
  month = month < 10 ? `0${month}` : month;
  const dPlus2 = `${dayPlus2}${month}${year}`;
  tokenData.datePart = `${dayPlus10}`;
  tokenData.D2_ddMMMyyyy = dPlus2;
  tokenData[DATE_FORMAT] = getDateTimeDDMMYYY(date);

  const template = dataMap[TEMPLATE];
  const dept = template?.dept ? template?.dept : 2;
  const retn = template?.retn ? template?.retn : 4;

  dataMap.noOfDaysToAddInDept = dept;
  dataMap.noOfDaysToAddInReturn = retn;

  tokenData[TOKEN_ROUTE_URL_PATH] = dataMap[TOKEN_ROUTE_URL_PATH] || null;

  try {
    tokenData.h1Header = template?.h_1_header || "";
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("H1 header/content not found for International Flights");
  }

  if (dataMap[IFCITY]) {
    try {
      const city = dataMap[IFCITY];
      const country = dataMap[IFCOUNTRY] || null;
      let intlAirport = null;
      if (dataMap[IF_AIRPORT_LIST]) {
        const intlAirportList = dataMap[IF_AIRPORT_LIST];
        intlAirport = intlAirportList.length > 0 ? intlAirportList[0] : null;
      } else if (dataMap[IFAIRPORT]) {
        intlAirport = dataMap[IFAIRPORT];
      }
      if (city) {
        tokenData[TOKEN_CITY_NAME] = city?.name || "";
        tokenData[TOKEN_AR_CITY_NAME] = city?.name_arabic || "";
        tokenData[TOKEN_HI_CITY_NAME] = city?.name_hindi || city?.hindi_name || "";
        tokenData[TOKEN_ABOUT_CITY] = getAboutCityValue(city, dataMap);
        tokenData[TOKEN_CITY_CODE] = city?.city_code || "";
        tokenData[TOKEN_CITY_URL] = city?.url_phrase || "";
        tokenData[TOKEN_AIRPORT_NAME] =
          intlAirport && intlAirport.name && intlAirport.name !== ""
            ? intlAirport.name
            : `${city.name} Airport`;
        tokenData[TOKEN_AIRPORT_DESCRIPTION] =
          intlAirport && intlAirport.airport_description && intlAirport.airport_description !== ""
            ? intlAirport.airport_description
            : "";
        tokenData[TOKEN_CITY_PLACE_CODE] = city.place_code || null;
        tokenData[TOKEN_LOCUS_CITY_CODE] = city.locus_city_code || `CT${city?.city_code}`;
        tokenData.country_code = city?.country_id || null;
        // Case where Airport is mapped with Country
        if (dataMap[AIRPORT_MAPPED_TO_COUNTRY]) {
          intlAirport = dataMap[IFAIRPORT];
          tokenData[TOKEN_SRC_CITY_NAME] = intlAirport ? intlAirport?.name : "";
          tokenData[TOKEN_SRC_CITY_FLIGHT_CODE] = intlAirport?.code || "";
        } else {
          tokenData[TOKEN_SRC_CITY_NAME] = city?.name || "";
          tokenData[TOKEN_AR_SRC_CITY_NAME] = city?.name_arabic || "";
          tokenData[TOKEN_SRC_CITY_FLIGHT_CODE] = city?.city_code || "";
        }
      }
      tokenData[TOKEN_SRC_COUNTRY_NAME] = country ? country.name : "";
      tokenData[TOKEN_HI_SRC_COUNTRY_NAME] = country ? country.name_hindi : "";
      tokenData[TOKEN_AR_SRC_COUNTRY_NAME] = country ? country.name_arabic : "";
      tokenData[TOKEN_SRC_COUNTRY_CODE] = country ? country.code : "";
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = error;
      dataMap.functionName = "setIntlTokens 1st catch: tokens";
      console.error("errorSetIntlTokensCatch", error);
    }
  }

  if (dataMap[INTL_AIRLINE]) {
    const airline = dataMap[INTL_AIRLINE];
    tokenData[TOKEN_ABOUT_AIRLINE_TEXT] = airline?.about_airline ? airline.about_airline : "";
    tokenData[TOKEN_AIRLINE_DESCRIPTION] = airline?.airline_description
      ? airline.airline_description
      : "";
    tokenData[TOKEN_AIRLINE_HISTORY] = airline?.airline_history ? airline.airline_history : "";
    tokenData[TOKEN_AIRLINE_INFLIGHT_SERVICES] = airline?.inflight_services
      ? airline.inflight_services
      : "";
    tokenData[TOKEN_AIRLINE_LOGO_URL] = airline.airline_logo_url ? airline.airline_logo_url : "";
    tokenData[TOKEN_AIRLINE_BAGGAGE_INFO_HTML] = airline?.airline_baggage_info_html
      ? airline?.airline_baggage_info_html
      : "";
    tokenData[TOKEN_AIRLINE_CONTACT_INFO_HTML] = airline?.airline_contact_info_html
      ? airline?.airline_contact_info_html
      : "";
    tokenData[TOKEN_AIRLINE_WEB_CHECKIN_HTML] = airline?.airline_web_checkin_html
      ? airline?.airline_web_checkin_html
      : "";
    tokenData[TOKEN_AIRLINE_INSURANCE_HTML] = airline?.airline_insurance_html
      ? airline?.airline_insurance_html
      : "";
    tokenData[TOKEN_AIRLINE_SERVICES_HTML] = airline?.airline_services_html
      ? airline?.airline_services_html
      : "";
    tokenData[TOKEN_AIRLINE_NAME] = airline?.name ? airline.name : "";
    if (url && url.includes(ARABIC_URL_CHECK))
      tokenData[TOKEN_AR_AIRLINE_NAME] = airline?.name_arabic ? airline?.name_arabic : "";
    tokenData[TOKEN_H1_TITLE] = airline?.name ? airline?.name : "";
    tokenData[TOKEN_AIRLINE_CODE] = airline?.code ? airline?.code : "";
    tokenData[TOKEN_AIRLINE_URL_PHRASE] = airline?.url_phrase ? airline?.url_phrase : "";
    tokenData[TOKEN_AIRLINE_AL_URL_PHRASE] = airline?.al_url_phrase ? airline?.al_url_phrase : "";
    tokenData[TOKEN_AIRLINE_CODE_LOWER_CASE] = airline?.code ? airline?.code.toLowerCase() : "";
  }

  if (dataMap[IFAIRPORT]) {
    try {
      const airport = dataMap[IFAIRPORT];
      const city = dataMap[IFCITY];
      tokenData[TOKEN_AIRPORT_NAME] = airport?.name
        ? getDisplayableName(airport?.name)
        : `${city.name} Airport`;
      tokenData[TOKEN_AIRPORT_URL_PHRASE] = airport?.url_phrase || "";
      tokenData[TOKEN_ABOUT_AIRPORT] =
        airport?.name && airport?.airport_description ? airport.airport_description : "";
      tokenData[TOKEN_AIRPORT_ADDRESS] = airport?.contact_details
        ? airport?.contact_details
        : city.name;
      tokenData[TOKEN_AIRPORT_LATITUDE] = airport?.latitude || "";
      tokenData[TOKEN_AIRPORT_LONGITUDE] = airport?.longitude || "";
      tokenData[TOKEN_AIRPORT_CODE] = airport?.code || "";
      tokenData[TOKEN_AIRPORT_CODE_LOWER_CASE] = airport?.code ? airport.code.toLowerCase() : "";
      tokenData[TOKEN_ABOUT_AIRPORT_CITY] = airport?.about_airport_city_desc || "";
      tokenData[TOKEN_AIRPORT_DESCRIPTION] = airport?.airport_description || "";
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = error;
      dataMap.functionName = "setIntlTokens 2nd catch: tokens";
      console.error("errorSetIntlTokensCatch2", error);
    }
  }

  if (dataMap[IF_SRC_CITY] || dataMap[IF_DEST_CITY]) {
    try {
      const srcCity = dataMap[IF_SRC_CITY];
      const destCity = dataMap[IF_DEST_CITY];

      let intlSrcCityAirport = null;
      let intlDestCityAirport = null;
      if (dataMap[IF_SRC_CITY_AIRPORT_LIST] && dataMap[IF_DEST_CITY_AIRPORT_LIST]) {
        const intlSrcCityAirportList = dataMap[IF_SRC_CITY_AIRPORT_LIST];
        const intlDestCityAirportList = dataMap[IF_DEST_CITY_AIRPORT_LIST];
        if (intlSrcCityAirportList.length > 0) {
          [intlSrcCityAirport] = intlSrcCityAirportList;
        }
        if (intlDestCityAirportList.length > 0) {
          [intlDestCityAirport] = intlDestCityAirportList;
        }

        tokenData[TOKEN_SRC_CITY_AIRPORT_NAME] =
          intlSrcCityAirport && intlSrcCityAirport.name ? intlSrcCityAirport.name : "";
        tokenData[TOKEN_DEST_CITY_AIRPORT_NAME] =
          intlDestCityAirport && intlDestCityAirport.name ? intlDestCityAirport.name : "";
        tokenData[TOKEN_SRC_CITY_AIRPORT_DESCRIPTION] =
          intlSrcCityAirport && intlSrcCityAirport.airport_description
            ? intlSrcCityAirport.airport_description
            : "";
        tokenData[TOKEN_DEST_CITY_AIRPORT_DESCRIPTION] =
          intlDestCityAirport && intlDestCityAirport.airport_description
            ? intlDestCityAirport.airport_description
            : "";
        tokenData[TOKEN_SRC_CITY_AIRPORT_ADDRESS] = intlSrcCityAirport?.contact_details || "";
        tokenData[TOKEN_DEST_CITY_AIRPORT_ADDRESS] = intlDestCityAirport?.contact_details || "";
        tokenData[TOKEN_DEST_CITY_AIRPORT_CODE] = intlDestCityAirport?.code || "";
        tokenData[TOKEN_SRC_CITY_AIRPORT_CODE] = intlSrcCityAirport?.code || "";
      }

      // tokenData.put("no_of_flights", "10");
      if (srcCity) {
        tokenData[TOKEN_SRC_CITY_NAME] = srcCity?.name || "";
        // Only for Goibibo
        if (dataMap.isGoibibo && url && url.includes(HINDI_URL_CHECK) && srcCity?.hindi_name) {
          tokenData[TOKEN_SRC_CITY_NAME] = srcCity?.hindi_name || "";
        }
        tokenData[TOKEN_ABOUT_SRC_CITY] = getAboutCityValue(srcCity, dataMap);
        tokenData[TOKEN_SRC_CITY_CODE] = srcCity?.city_code || "";
        tokenData[TOKEN_SRC_LOCUS_CODE] = srcCity?.locus_city_code || `CT${srcCity?.flight_city_code}`;
        tokenData[TOKEN_SRC_CITY_URL] = srcCity?.url_phrase || "";

        tokenData[TOKEN_SRC_CITY_PLACE_CODE] = srcCity?.place_code || "";

        tokenData[TOKEN_DES_CITY_NAME] = destCity?.name || "";
        // Only for Goibibo
        if (dataMap.isGoibibo && url && url.includes(HINDI_URL_CHECK) && destCity?.hindi_name) {
          tokenData[TOKEN_DES_CITY_NAME] = destCity?.hindi_name || "";
        }
        tokenData[TOKEN_ABOUT_DEST_CITY] = getAboutCityValue(destCity, dataMap);
        tokenData[TOKEN_DES_CITY_CODE] = destCity?.city_code || "";
        tokenData[TOKEN_DES_LOCUS_CODE] = destCity?.locus_city_code || `CT${destCity?.flight_city_code}`;
        tokenData[TOKEN_DEST_CITY_URL] = destCity?.url_phrase || "";
        tokenData[TOKEN_DES_CITY_PLACE_CODE] = destCity?.place_code || "";
        tokenData[TOKEN_AR_SRC_CITY_NAME] = srcCity?.name_arabic || "";
        tokenData[TOKEN_AR_DES_CITY_NAME] = destCity?.name_arabic || "";
        tokenData[TOKEN_HI_SRC_CITY_NAME] = srcCity?.name_hindi || srcCity?.hindi_name || "";
        tokenData[TOKEN_HI_DES_CITY_NAME] = destCity?.name_hindi || destCity?.hindi_name || "";
      }
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = error;
      dataMap.functionName = "setIntlTokens 3rd catch: tokens";
      console.error("errorSetIntlTokensCatch3", error);
    }
  }

  if (dataMap[IF_SRC_CITY] && dataMap[IF_DEST_CITY]) {
    const srcCity = dataMap[IF_SRC_CITY];
    const destCity = dataMap[IF_DEST_CITY];
    try {
      const distance = getAerialDistanceFromLatLong(
        srcCity.latitude,
        srcCity.longitude,
        destCity.latitude,
        destCity.longitude,
      );
      tokenData.aerial_distance = distance || "";
      tokenData.distance = distance || "";
      tokenData[TOKEN_ROAD_DISTANCE] = distance || "";
    } catch (error) {
      tokenData.aerial_distance = " ";
      tokenData.distance = " ";
      tokenData[TOKEN_ROAD_DISTANCE] = " ";
      // eslint-disable-next-line no-console
      console.error("errorInvalidDistancTokens", error);
    }
  }

  if (dataMap[IFCOUNTRY]) {
    try {
      const country = dataMap[IFCOUNTRY];

      tokenData[TOKEN_COUNTRY_NAME] = country?.name ? country.name : "";
      tokenData[TOKEN_HI_COUNTRY_NAME] = country?.name_hindi ? country.name_hindi : "";
      tokenData[TOKEN_AR_COUNTRY_NAME] = country?.name_arabic ? country.name_arabic : "";
      tokenData[TOKEN_COUNTRY_CODE] = country?.code ? country.code : "";
      tokenData[TOKEN_COUNTRY_URL] = country?.url_phrase ? country.url_phrase : "";
      tokenData[TOKEN_COUNTRY_PLACE_CODE] = country?.place_code ? country.place_code : "";
      tokenData[TOKEN_ABOUT_COUNTRY] = country?.description ? country.description : "";
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("errorInvalidIFCOUNTRYTokens", error);
    }
  }

  if (dataMap[IF_SRC_COUNTRY]) {
    try {
      const country = dataMap[IF_SRC_COUNTRY];
      tokenData[TOKEN_SRC_COUNTRY_NAME] = country?.name ? country.name : "";
      tokenData[TOKEN_HI_SRC_COUNTRY_NAME] = country?.name_hindi ? country.name_hindi : "";
      tokenData[TOKEN_AR_SRC_COUNTRY_NAME] = country?.name_arabic ? country.name_arabic : "";
      tokenData[TOKEN_SRC_COUNTRY_CODE] = country?.code ? country.code : "";
      tokenData[TOKEN_SRC_COUNTRY_URL] = country?.url_phrase ? country.url_phrase : "";
      tokenData[TOKEN_SRC_COUNTRY_PLACE_CODE] = country?.place_code ? country.place_code : "";
      tokenData[TOKEN_ABOUT_SRC_COUNTRY] = country?.description ? country.description : "";
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("errorInvalidIF_SRC_COUNTRYTokens", error);
    }
  }

  if (dataMap[IF_DEST_COUNTRY]) {
    try {
      const country = dataMap[IF_DEST_COUNTRY];
      tokenData[TOKEN_DES_COUNTRY_NAME] = country?.name ? country.name : "";
      tokenData[TOKEN_AR_DES_COUNTRY_NAME] = country?.name_arabic ? country.name_arabic : "";
      tokenData[TOKEN_HI_DES_COUNTRY_NAME] = country?.name_hindi ? country.name_hindi : "";
      tokenData[TOKEN_DES_COUNTRY_CODE] = country?.code ? country.code : "";
      tokenData[TOKEN_DES_COUNTRY_URL] = country?.url_phrase ? country.url_phrase : "";
      tokenData[TOKEN_DES_COUNTRY_PLACE_CODE] = country?.place_code ? country.place_code : "";
      tokenData[TOKEN_ABOUT_DES_COUNTRY] = country?.description ? country.description : "";
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("errorInvalidIF_DEST_COUNTRYTokens", error);
    }
  }

  if (dataMap[PATH_VAR_ALPHA]) {
    tokenData[PATH_VAR_ALPHA] = dataMap[PATH_VAR_ALPHA];
  }

  if (dataMap[PATH_VAR_ALPHA_DIGIT]) {
    tokenData[PATH_VAR_ALPHA_DIGIT] = dataMap[PATH_VAR_ALPHA_DIGIT];
  }

  if (dataMap[URL_ATTRIBUTE_COUNTRY]) {
    tokenData.country_url_phrase = dataMap[URL_ATTRIBUTE_COUNTRY];
  }

  if (dataMap[TOKEN_COUNTRY_FOLDER_CODE]) {
    tokenData[TOKEN_COUNTRY_FOLDER_CODE] = dataMap[TOKEN_COUNTRY_FOLDER_CODE];
    tokenData[TOKEN_CURRENCY_CODE] = dataMap[TOKEN_CURRENCY_CODE];
  } else {
    tokenData[TOKEN_CURRENCY_CODE] = tokenData[TOKEN_CURRENCY_CODE] || "INR";
  }

  return tokenData;
};

export const setFlightTokens = (data, tokens) => {
  const dataMap = { ...data };
  const tokenData = { ...tokens };
  const url = dataMap[URL_CURRENT];
  if (url && url.startsWith("/")) {
    tokenData.url = url.substring(1);
  }

  tokenData[TOKEN_ROUTE_URL_PATH] = dataMap[TOKEN_ROUTE_URL_PATH] || "";
  tokenData[TOKEN_CURRENCY_CODE] = "INR";
  if (dataMap[SRC_CITY] && dataMap[DEST_CITY]) {
    try {
      const src = dataMap[SRC_CITY];
      const dest = dataMap[DEST_CITY];
      tokenData[TOKEN_SRC_CITY_NAME] = src?.name;
      if (url && url.includes(HINDI_URL_CHECK) && src?.hindi_name) {
        tokenData[TOKEN_SRC_CITY_NAME] = src?.hindi_name;
      }

      tokenData[TOKEN_SRC_CITY_FLIGHT_CODE] = src?.flight_city_code || "";
      tokenData[TOKEN_SRC_LOCUS_CODE] = src?.locus_city_code || `CT${src?.flight_city_code}`;
      tokenData[TOKEN_SRC_CITY_PLACE_CODE] = src?.place_code || "";
      tokenData[TOKEN_CITY_PLACE_CODE] = src?.place_code || null;
      tokenData[TOKEN_SRC_CITY_URL] = src?.flights_url_phrase || null;

      tokenData[TOKEN_DES_CITY_NAME] = dest?.name;
      if (url && url.includes(HINDI_URL_CHECK) && dest?.hindi_name) {
        tokenData[TOKEN_DES_CITY_NAME] = dest?.hindi_name || "";
      }
      tokenData[TOKEN_DES_CITY_FLIGHT_CODE] = dest?.flight_city_code || "";
      tokenData[TOKEN_DES_LOCUS_CODE] = dest?.locus_city_code || `CT${dest?.flight_city_code}`;
      tokenData[TOKEN_DES_CITY_PLACE_CODE] = dest?.place_code || "";
      tokenData[TOKEN_DEST_CITY_URL] = dest?.flights_url_phrase;
      if (dataMap[AIRLINE]) {
        tokenData[TOKEN_AIRLINE_NAME] = dataMap[AIRLINE]?.name;
        if (url && url.includes(HINDI_URL_CHECK)) {
          const airline = dataMap[AIRLINE];
          if (airline?.hindi_name) {
            tokenData[TOKEN_AIRLINE_NAME] = airline?.hindi_name;
          }
        }
      }

      try {
        const template = dataMap[TEMPLATE];
        tokenData.h1Header = template?.h_1_header || "";
        tokenData.seoContent = template?.seo_content || "";
      } catch (error) {
        dataMap.HTTP_STATUS_CODE = 404;
        dataMap.error = "H1 header/content not found";
        dataMap.functionName = "setFlightTokens 1st catch: Tokens";
        console.error("errorSetFlightTokensCatch1", error);
      }

      if (dataMap[SRC_AIRPORT] && dataMap[DEST_AIRPORT]) {
        try {
          const srcAirport = dataMap[SRC_AIRPORT];
          const dstAirport = dataMap[DEST_AIRPORT];
          let sourceAirport = null;
          let destAirport = null;
          if (srcAirport?.length !== 0) {
            sourceAirport = Array.isArray(srcAirport) ? srcAirport[0] : srcAirport;
          }
          if (dstAirport?.length !== 0) {
            destAirport = Array.isArray(dstAirport) ? dstAirport[0] : dstAirport;
          }
          const srcApt = sourceAirport;
          const destApt = destAirport;
          if (srcApt) {
            tokenData.src_airport_url_phrase = getAirportUrl(
              srcApt?.url_phrase,
              srcApt?.city_code?.toLowerCase(),
              src?.flights_url_phrase,
            );
            tokenData.src_airport_name = srcApt?.name
              ? getDisplayableName(srcApt?.name)
              : src?.name;
            tokenData.source_city_airport_code = srcApt?.code || "";
            tokenData.src_airport_address = srcApt?.contact_details || "";
            if (url && url.includes(HINDI_URL_CHECK) && srcApt?.hindi_name) {
              tokenData.src_airport_name = srcApt?.hindi_name;
            }
          }
          if (destApt) {
            tokenData.dest_airport_url_phrase = getAirportUrl(
              destApt?.url_phrase,
              destApt?.city_code?.toLowerCase(),
              dest?.flights_url_phrase,
            );
            tokenData.dest_airport_name = destApt?.name
              ? getDisplayableName(destApt?.name)
              : dest?.name;
            tokenData.destination_city_airport_code = destApt?.code || "";
            tokenData.dest_airport_address = destApt?.contact_details || "";
            if (url && url.includes(HINDI_URL_CHECK) && destApt?.hindi_name) {
              tokenData.dest_airport_name = dest?.hindi_name;
            }
          }
        } catch (error) {
          dataMap.HTTP_STATUS_CODE = 404;
          dataMap.error = "Not Valid Data";
          dataMap.functionName = "setFlightTokens 2nd catch: Tokens";
          console.error("errorSetFlightTokensCatch2", error);
        }
      }
      const date = new Date();
      tokenData[DATE_FORMAT] = getDateTimeDDMMYYY(date);
      let dayPlus1 = date.getDate() + 1;
      let dayPlus2 = date.getDate() + 2;
      let dayPlus4 = date.getDate() + 4;
      let month = date.getMonth() + 1;
      const year = date.getFullYear();
      dayPlus2 = dayPlus2 < 10 ? `0${dayPlus2}` : dayPlus2;
      dayPlus4 = dayPlus4 < 10 ? `0${dayPlus4}` : dayPlus4;
      month = month < 10 ? `0${month}` : month;
      tokenData.datePart = `${dayPlus1}`;
      tokenData[DATE_FORMAT_PLUS_2] = `${dayPlus2}-${month}-${year}`;
      tokenData[DATE_FORMAT_PLUS_D2] = `${month}${dayPlus2}${year}`;
      tokenData[DATE_FORMAT_PLUS_4] = `${dayPlus4}-${month}-${year}`;
      tokenData.retun_url = `<a href=${getFareCalendarUrl(
        dest?.flights_url_phrase,
        src?.flights_url_phrase,
      )}>${dest?.name} to ${src?.name}</a>`;
      tokenData.schedule_url = `<a href=${getFlightScheduleUrl(
        src?.flights_url_phrase,
        dest?.flights_url_phrase,
      )}>${src?.name} to ${dest?.name}</a>`;
      tokenData.route_url = `<a href=${getSeoFlightUrl(
        src?.flights_url_phrase,
        dest?.flights_url_phrase,
        dataMap.isIntl,
      )}>${src?.name} to ${dest?.name}</a>`;
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = error;
      dataMap.functionName = "setFlightTokens 3rd catch: Tokens";
      console.error("errorSetFlightTokensCatch3", error);
    }
  }
  if (dataMap[ENTITY_TYPE_AIRLINE] || dataMap[AIRLINE]) {
    try {
      let airline = null;
      if (dataMap[ENTITY_TYPE_AIRLINE]) {
        airline = dataMap[ENTITY_TYPE_AIRLINE];
      } else if (dataMap[AIRLINE]) {
        airline = dataMap[AIRLINE];
      }
      if (airline) {
        tokenData[TOKEN_PNR_STATUS_URL] = AIRLINE_TO_PNR_MAP[airline.url_phrase] || "";
        tokenData[TOKEN_ABOUT_AIRLINE_TEXT] = airline?.about_airline ? airline?.about_airline : "";
        tokenData[TOKEN_AIRLINE_LOGO_URL] = airline?.airline_logo_url
          ? airline?.airline_logo_url
          : "";
        tokenData[TOKEN_AIRLINE_BAGGAGE_INFO_HTML] = airline?.airline_baggage_info_html
          ? airline?.airline_baggage_info_html
          : "";
        tokenData[TOKEN_AIRLINE_CONTACT_INFO_HTML] = airline?.airline_contact_info_html
          ? airline?.airline_contact_info_html
          : "";
        tokenData[TOKEN_AIRLINE_WEB_CHECKIN_HTML] = airline?.airline_web_checkin_html
          ? airline?.airline_web_checkin_html
          : "";
        tokenData[TOKEN_AIRLINE_INSURANCE_HTML] = airline?.airline_insurance_html
          ? airline?.airline_insurance_html
          : "";
        tokenData[TOKEN_AIRLINE_SERVICES_HTML] = airline?.airline_services_html
          ? airline?.airline_services_html
          : "";
        if (url && url.includes(HINDI_URL_CHECK) && airline?.hindi_name) {
          tokenData[TOKEN_AIRLINE_NAME] = airline?.hindi_name;
          tokenData[TOKEN_H1_TITLE] = airline?.hindi_name ? airline?.name : "";
        } else {
          tokenData[TOKEN_AIRLINE_NAME] = airline?.name ? airline?.name : "";
          tokenData[TOKEN_H1_TITLE] = airline?.name ? airline?.name : "";
        }
        tokenData[TOKEN_AIRLINE_CODE] = airline?.code ? airline?.code : "";
        tokenData[TOKEN_AIRLINE_URL_PHRASE] = airline?.url_phrase ? airline?.url_phrase : "";
        tokenData[TOKEN_HINDI_PAGES_AIRLINE_URL_PHRASE] =
          airline?.hi_pages_url_phrase && airline?.hi_pages_url_phrase?.length > 0
            ? airline?.hi_pages_url_phrase
            : "";
      }
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = "Invalid airline";
      dataMap.functionName = "setFlightTokens 4th catch: Tokens";
      console.error("errorSetFlightTokensCatch4", error);
    }
  }

  if (dataMap[AIRPORT]) {
    try {
      const airport = dataMap[AIRPORT];
      const city = dataMap[CITY];
      const { country } = dataMap;
      if (url && url.includes(HINDI_URL_CHECK) && airport?.hindi_name) {
        if (city?.hindi_name) {
          tokenData[
            TOKEN_AIRPORT_NAME
          ] = `${airport?.hindi_name} ${city?.hindi_name}${AIRPORT_NAME}`;
        } else {
          tokenData[TOKEN_AIRPORT_NAME] = `${airport?.hindi_name} ${city?.name}${AIRPORT_NAME}`;
        }
      } else {
        tokenData[TOKEN_AIRPORT_NAME] = airport?.name
          ? getDisplayableName(airport?.name)
          : `${city?.name} Airport`;
      }
      tokenData[TOKEN_ABOUT_AIRPORT] = airport?.name ? airport?.airport_description : "";
      tokenData[TOKEN_ABOUT_AIRPORT_CITY] = airport?.name ? airport?.about_airport_city_desc : "";
      tokenData[TOKEN_AIRPORT_ADDRESS] = airport?.contact_details
        ? airport?.contact_details
        : city?.name;
      tokenData[TOKEN_AIRPORT_URL] = `${airport?.url_phrase}-${airport?.city_code?.toLowerCase()}-${
        city.flights_url_phrase
      }`;
      tokenData[TOKEN_AIRPORT_LATITUDE] = airport?.latitude || "";
      tokenData[TOKEN_AIRPORT_LONGITUDE] = airport?.longitude || "";
      if (country) {
        tokenData[TOKEN_AIRPORT_COUNTRY] = country.name;
      }
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = "invalid airport";
      dataMap.functionName = "setFlightTokens 5th catch: Tokens";
      console.error("errorSetFlightTokensCatch5", error);
    }
  }
  if (dataMap[CITY]) {
    try {
      const city = dataMap[CITY];
      if (city) {
        if (url && url.includes(HINDI_URL_CHECK) && city?.hindi_name) {
          tokenData[TOKEN_CITY_NAME] = city?.hindi_name;
          tokenData[TOKEN_ABOUT_CITY] = city?.about_city ? city.about_city : city.hindi_name;
        } else {
          tokenData[TOKEN_CITY_NAME] = city?.name;
          tokenData[TOKEN_ABOUT_CITY] = city?.about_city ? city.about_city : city.name;
        }
        tokenData[TOKEN_CITY_CODE] = city.flight_city_code;
        tokenData[TOKEN_LOCUS_CITY_CODE] = city?.locus_city_code || `CT${city?.flight_city_code}`;
        tokenData[TOKEN_FLIGHT_CITY] = city.flight_city_code;
        tokenData[TOKEN_CITY_FLIGHT_CODE] = city.flight_city_code;
        tokenData[TOKEN_CITY_URL] = city.url_phrase;
        tokenData[TOKEN_FLIGHT_CITY_URL] = city.flights_url_phrase;
        tokenData[TOKEN_CITY_URL_PHRASE] = city.flights_url_phrase;
        tokenData[TOKEN_CITY_PLACE_CODE] = city?.place_code || null;
        tokenData.country_code = city?.country_id || null;
        if (DF_CITY_TEMPLATE === dataMap[CURRENT_TEMPLATE]) {
          if (url && url.includes(HINDI_URL_CHECK) && city?.hindi_name) {
            if (!tokenData.dest_city_code) {
              tokenData.dest_city_name = city.hindi_name;
              tokenData.dest_city_code = city.flight_city_code;
            }
          } else if (!tokenData.dest_city_code) {
            tokenData.dest_city_name = city.name;
            tokenData.dest_city_code = city.flight_city_code;
          }
        }
        if (url && url.includes(HINDI_URL_CHECK) && city?.hindi_name) {
          if (!tokenData.src_city_code) {
            tokenData.src_city_name = city.hindi_name;
            tokenData.src_city_code = city.flight_city_code;
          }
        } else if (!tokenData.src_city_code) {
          tokenData.src_city_name = city.name;
          tokenData.src_city_code = city.flight_city_code;
        }
      }
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = "invalid city";
      dataMap.functionName = "setFlightTokens 6th catch: Tokens";
      console.error("errorSetFlightTokensCatch6", error);
    }
  }
  if (dataMap[IF_DEST_COUNTRY]) {
    try {
      const country = dataMap[IF_DEST_COUNTRY];
      tokenData[TOKEN_DES_COUNTRY_NAME] = country?.name ? country?.name : "";
      tokenData[TOKEN_HI_DES_COUNTRY_NAME] = country?.hindi_name ? country?.hindi_name : "";
      tokenData[TOKEN_AR_DES_COUNTRY_NAME] = country?.name_arabic ? country?.name_arabic : "";
      tokenData[TOKEN_DES_COUNTRY_CODE] = country?.code ? country.code : "";
      tokenData[TOKEN_DES_COUNTRY_URL] = country?.url_phrase ? country.url_phrase : "";
      tokenData[TOKEN_DES_COUNTRY_PLACE_CODE] = country?.place_code ? country?.place_code : "";
      tokenData[TOKEN_ABOUT_DES_COUNTRY] = country?.description ? country?.description : "";
    } catch (error) {
      dataMap.HTTP_STATUS_CODE = 404;
      dataMap.error = "invalid if_dest_country";
      dataMap.functionName = "setFlightTokens 7th catch: Tokens";
      console.error("errorSetFlightTokensCatch7", error);
    }
  }
  if (dataMap[PATH_VAR_ALPHA]) {
    tokenData.alphabetInUrl = dataMap[PATH_VAR_ALPHA];
  }

  if (dataMap[PATH_VAR_ALPHA_DIGIT]) {
    tokenData.alphabetInUrl = dataMap[PATH_VAR_ALPHA_DIGIT];
  }

  if (
    (dataMap[TEMPLATE] && !dataMap[`${TEMPLATE}_type`] && dataMap[`${TEMPLATE}_type`] == null) ||
    !(dataMap[`${TEMPLATE}_type`] === "static_pages_template")
  ) {
    const template = dataMap[TEMPLATE] || {};
    if (DF_DISTANCE_TEMPLATE === template.template_type) {
      const jrnySrcCity = dataMap[JRNY_SRC_CITY];
      const jrnyDestCity = dataMap[JRNY_DEST_CITY];

      tokenData.jrny_src_city_name = jrnySrcCity?.name;
      tokenData.jrny_src_city_code = jrnySrcCity?.flight_city_code
        ? jrnySrcCity?.flight_city_code
        : jrnySrcCity?.city_code;
      tokenData.jrny_src_city_placecode = jrnySrcCity?.place_code || "";
      tokenData.jrny_src_city_url = jrnySrcCity?.flights_url_phrase
        ? jrnySrcCity?.flights_url_phrase
        : jrnySrcCity?.url_phrase;

      tokenData.jrny_dest_city_name = jrnyDestCity?.name;
      tokenData.jrny_dest_city_code = jrnyDestCity?.flight_city_code
        ? jrnyDestCity?.flight_city_code
        : jrnyDestCity?.city_code;
      tokenData.jrny_dest_city_placecode = jrnyDestCity?.place_code || "";
      tokenData.jrny_dest_city_url = jrnyDestCity?.flights_url_phrase
        ? jrnyDestCity?.flights_url_phrase
        : jrnyDestCity?.url_phrase;
    }
  }
  return tokenData;
};

export const setSeoContentTokens = (data) => {
  const dataMap = { ...data };
  const tokenData = dataMap?.tokens;
  tokenData.currency = getCurrencyForCountry(dataMap);
  dataMap.currency = tokenData?.currency;
  if (dataMap?.isIntl) {
    const ifTemplate = dataMap[TEMPLATE];
    if (ifTemplate?.content_top) {
      tokenData.seoContentTop = tokenReplace(ifTemplate?.content_top, dataMap?.tokens);
    }
    if (!tokenData.seoContentTop && ifTemplate?.seo_content) {
      tokenData.seoContentTop = giTokenReplace(ifTemplate?.seo_content, dataMap?.tokens);
    }
    dataMap.tokens = { ...tokenData };
    return dataMap;
  }
  let seoContentStr = tokenData?.seoContent;
  if (seoContentStr && seoContentStr?.length > 0) {
    seoContentStr = tokenReplace(seoContentStr, tokenData);
    // if (seoContentStr?.includes(`\${${TOKEN_SRC_CITY_NAME}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_SRC_CITY_NAME}}`, tokenData[TOKEN_SRC_CITY_NAME]);
    // }
    // if (seoContentStr?.includes(`\${${TOKEN_DES_CITY_NAME}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_DES_CITY_NAME}}`, tokenData[TOKEN_DES_CITY_NAME]);
    // }
    // if (seoContentStr?.includes(`\${${TOKEN_SRC_CITY_URL}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_SRC_CITY_URL}}`, tokenData[TOKEN_SRC_CITY_URL]);
    // }
    // if (seoContentStr?.includes(`\${${TOKEN_DEST_CITY_URL}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_DEST_CITY_URL}}`, tokenData[TOKEN_DEST_CITY_URL]);
    // }
    // if (seoContentStr?.includes(`\${${TOKEN_AIRLINE_NAME}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_AIRLINE_NAME}}`, tokenData[TOKEN_AIRLINE_NAME]);
    // }
    // if (seoContentStr?.includes(`\${${TOKEN_SRC_CITY_CODE}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_SRC_CITY_CODE}}`, tokenData[TOKEN_SRC_CITY_CODE]);
    // }
    // if (seoContentStr?.includes(`\${${TOKEN_DES_CITY_CODE}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_DES_CITY_CODE}}`, tokenData[TOKEN_DES_CITY_CODE]);
    // }
    // if (seoContentStr?.includes(`\${${TOKEN_AIRLINE_URL_PHRASE}}`)) {
    //   seoContentStr = seoContentStr?.replaceAll(`\${${TOKEN_AIRLINE_URL_PHRASE}}`, tokenData[TOKEN_AIRLINE_URL_PHRASE]);
    // }
    tokenData.isShowSeoContent = true;
  }
  tokenData.seoContentResolved = seoContentStr || null;
  dataMap.tokens = { ...tokenData };

  return dataMap;
};

export const addCheapFlightInfoTokens = (journey, card, token) => {
  const tokenData = { ...token };
  if (card) {
    tokenData.cheap0airline_name = card.simpleAirlineHeading.nm;
  }
  if (journey) {
    tokenData.cheap0arvt = journey.arrTime;
    tokenData.cheap0dept = journey.depTime;
  }
  return tokenData;
};
